// extracted by mini-css-extract-plugin
module.exports = {"pageHolder":"Support_pageHolder__10LrB","imageHolder":"Support_imageHolder__1UJJM","newChatBtn":"Support_newChatBtn__3QhVf"};